import React from 'react';
import { MdDownload } from "react-icons/md";
import { SERVER_URL } from '../../data';


const DownloadSHP = ({coords}) => {
  const handleDownload = async () => {
    const response = await fetch(SERVER_URL+'/download-shp', {
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body:JSON.stringify(coords)
    });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(new Blob([blob]));

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'points.zip');
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  return (
      <button onClick={handleDownload} className="btn btn-dark btn-lg" title='Download coordinates(shp)'><MdDownload size={20} /></button>
  );
};

export default DownloadSHP;
